import React from 'react'

import noop from 'lodash/noop'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

import CloseButton from '../close-button'
import LinkButton from '../link-button'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
    submitButton?: React.ReactElement
    onClose?: () => void
    onClear?: () => void
    headerContent?: React.ReactNode
    clearLabel: string
  }
>

const FilterSelectFlyout = ({
  className,
  children,
  headerContent,
  submitButton,
  clearLabel,
  onClose = noop,
  onClear = noop,
  ...props
}: Props) => (
  <div
    {...props}
    className={cn('FilterSelectFlyout', {hasHeaderContent: !!headerContent}, className)}
  >
    <div className="FilterSelectFlyout__header">
      <LinkButton onClick={onClear}>{clearLabel}</LinkButton>
      <CloseButton onClick={onClose} />
    </div>
    {headerContent && <div className="FilterSelectFlyout__headerContent">{headerContent}</div>}
    <div className="FilterSelectFlyout__content">{children}</div>
    {submitButton && <div className="FilterSelectFlyout__footer">{submitButton}</div>}
  </div>
)

export default FilterSelectFlyout
